var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v("기업회원 정보")]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-data-table', _vm._b({
    attrs: {
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.info.name`,
      fn: function (_ref2) {
        var item = _ref2.item,
          value = _ref2.value;
        return [_c('v-layout', {
          attrs: {
            "column": "",
            "align-center": ""
          }
        }, [_c('router-link', {
          staticClass: "mb-4 mb-lg-8",
          attrs: {
            "to": `/companies/${item._user}`
          }
        }, [_c('span', [_vm._v(" " + _vm._s(value) + " "), _c('v-icon', {
          attrs: {
            "size": "16"
          }
        }, [_vm._v("mdi-open-in-new")])], 1)]), _c('v-btn', {
          attrs: {
            "small": "",
            "outlined": "",
            "width": "100",
            "color": "grey-d",
            "to": `/companies/${item._user}`
          }
        }, [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v(" 채용공고 ")])])], 1)];
      }
    }, {
      key: `item.grant`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('employers-item-grant', _vm._b({
          on: {
            "input": _vm.updateItem
          }
        }, 'employers-item-grant', {
          value: item,
          program: _vm.program,
          isUserHost: _vm.isUserHost
        }, false))];
      }
    }, {
      key: `item.match`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('employers-item-match', _vm._b({}, 'employers-item-match', {
          program: _vm.program,
          employer: item,
          isUserHost: _vm.isUserHost,
          isUserEmployee: _vm.isUserEmployee,
          isUserEmployer: _vm.isUserEmployer
        }, false))];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider'), _c('v-pagination', {
          staticClass: "my-8",
          attrs: {
            "length": _vm.pageCount,
            "total-visible": 11,
            "color": "primary"
          },
          model: {
            value: _vm.page,
            callback: function ($$v) {
              _vm.page = $$v;
            },
            expression: "page"
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items,
    itemKey: '_id',
    itemsPerPage: -1,
    loading: _vm.loading
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }